import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const DemiBoldSpan = styled.span.withConfig({
  displayName: "UniversalAssociationsSelectOptionHeader__DemiBoldSpan",
  componentId: "sc-6ev9kw-0"
})(["font-weight:600;"]);
const UniversalAssociationsSelectOptionHeader = ({
  pluralObjectName
}) => {
  return /*#__PURE__*/_jsx(DemiBoldSpan, {
    className: "m-top-0 m-bottom-0",
    "data-unit-test": `${pluralObjectName}-associations-option-header`,
    children: pluralObjectName
  });
};
export default UniversalAssociationsSelectOptionHeader;